var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095708"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 10.3408,
    cy: 11.1357,
    r: 10.2148,
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1312",
    x: 6.08789,
    y: 10.4346,
    width: 8.50586,
    height: 1.40234,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleMinus);
export default __webpack_public_path__ + "static/media/icon-circle-minus.7752ea08279d5157d92513ecdc5abced.svg";
export { ForwardRef as ReactComponent };